import type { HelpFile } from '../../types/help'
import { RemoveRoleDialogTestIds } from '../../../testids/RemoveRoleDialogTestIds'

export const removeRoleDialogHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [RemoveRoleDialogTestIds.removeRoleDialogBody]:
      'Entfernung der Rolle von diesem Servicekonto bestätigen.',
    [RemoveRoleDialogTestIds.removeRoleDialogTitle]: 'Rolle entfernen',
  },
}
